<template>
  <div class="searchBox">
    <b-row>
      <b-col  class="my-1 my-sm-0">
        <b-form-select v-model="selected" :options="options"></b-form-select>
      </b-col>
      <!-- 選擇旅遊行程或旅館，不確定是否需要 -->
      <!-- <b-col cols="12" sm="auto" class="my-1 my-sm-0">
        <b-form-select v-model="searchType" :options="searchTypeOpt"></b-form-select>
      </b-col> -->
      <div>
        <!-- selectedCategory是子分類ID -->
        <a :href="'/tours/search/'+ selected" target="_blank" class="mx-3">
          <b-btn class="book_btn" :disabled="selected===null">{{$t('searchTxt')}}</b-btn>
        </a>
        <!-- <b-btn @click="search">搜</b-btn> -->
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    selectedCategory: {
      required: true
    }
  },
  data () {
    return {
      selected: this.selectedCategory
    }
  }
}
</script>

<style lang="scss">
.searchBox {
  background-color: rgba(255, 255, 255, 1);
  padding: 1.6em 1em;
  border-radius: .25em;
  // border: 1px solid;
  // transform: translatex(-50%);
  // position: absolute;
  z-index: 99;
  .custom-select {
    letter-spacing: 1px;
    color: #616161;
  }
  select {
    min-width: 246px;
  }
}
</style>
